import { render } from "./LegacyAlarmResolutionReportSettings.vue?vue&type=template&id=5890c7eb"
import script from "./LegacyAlarmResolutionReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyAlarmResolutionReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__